import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { Floor } from "shared/types/Floor"
import { ProjectChild, isProjectFloor } from "shared/types/Project"
import { SelectOption } from "shared/types/Select"

import { useProjectData } from "entities/projects/api/useProjectData"

export function useFloorOptions(projectID: string | null): {
  options: SelectOption<string | null, Floor>[]
  isLoading: boolean
} {
  const { t } = useTranslation()
  const { project, isLoading } = useProjectData(projectID, true)

  const options = useMemo<SelectOption<string | null, Floor>[]>(() => {
    const result =
      project?.children?.reduce(
        (acc: SelectOption<string | null, Floor>[], child: ProjectChild) => {
          if (isProjectFloor(child)) {
            return [
              ...acc,
              {
                key: child.id,
                label: child.label,
                value: child.id,
                data: child
              }
            ] as SelectOption<string | null, Floor>[]
          }
          return acc
        },
        []
      ) || []
    result.unshift({ value: projectID, label: t("Floor.NoFloor") })
    return result
  }, [project?.children, projectID, t])

  return { options, isLoading }
}
